<template>
    <div v-wechat-title="title">
        <el-row>
            <draggable tag="el-row" v-model="orderParts" v-bind="{ group: { name: 'card', pull: false, put: false }, animation: 150 }" @change="exchangeParts">
                <el-col :md="12" :xl="8" v-for="p in orderParts" :key="p.col_name">
                    <div class="grid-content" :style="{ height: `425px` }">
                        <div class="card">
                            <div style="float: left">
                                <i class="el-icon-s-order"></i>
                                <span>{{ p.col_name }}</span>
                            </div>

                            <div v-if="p.col_name == '手术管理'" style="float: right; margin-right: 10px; color: var(--primary-color, #3db5ba); cursor: pointer">
                                <i class="el-icon-s-data"></i>
                                <span>统计</span>
                            </div>
                            <div
                                v-else-if="p.col_name == '手术管理' || p.col_name == '消息中心'"
                                style="float: right; margin-right: 10px; color: var(--primary-color, #3db5ba); cursor: pointer"
                                @click="linkToMessage()"
                            >
                                <i class="el-icon-s-data"></i>
                                <span>更多</span>
                            </div>
                        </div>
                        <el-row v-if="p.col_name == '手术管理'" :gutter="5">
                            <el-col :span="12" :key="index" v-for="(chart, index) in charts">
                                <v-chart :options="chart" style="width: 100%; height: 250px" />
                            </el-col>
                        </el-row>
                        <div v-else-if="p.col_name == '月度手术例数'" style="margin: 15px">
                            <el-col :span="12">
                                <v-chart :options="option" style="width: 450px; height: 350px" />
                            </el-col>
                        </div>
                        <div v-else-if="p.col_name == '今日手术患者'" style="margin: 0 10px 0 10px">
                            <el-tabs v-model="activeName" @tab-click="handleClick">
                                <el-tab-pane v-for="item in todayData" :key="item.name" :label="item.label" :name="item.name">
                                    <div v-if="item.data.length === 0">暂无患者</div>
                                    <list-view v-else :columns="columns" :datalist="item.data" @extrabutton-click="ExtraButtonClick" :tableHeight="280" :showSequence="false"></list-view>
                                </el-tab-pane>
                            </el-tabs>
                        </div>
                        <div v-else-if="p.col_name == '明日手术患者'" style="margin: 0 10px 0 10px">
                            <el-tabs v-model="activeName1" @tab-click="handleClick1">
                                <el-tab-pane v-for="item in tomorrowData" :key="item.name" :label="item.label" :name="item.name">
                                    <div v-if="item.data.length === 0">暂无患者</div>
                                    <list-view v-else :columns="columns" :datalist="item.data" @extrabutton-click="ExtraButtonClick" :tableHeight="280" :showSequence="false"></list-view>
                                </el-tab-pane>
                            </el-tabs>
                        </div>
                        <div v-else-if="p.col_name == '7日手术患者'" style="margin: 0 10px 0 10px">
                            <el-tabs v-model="activeName2" @tab-click="handleClick2">
                                <el-tab-pane v-for="item in seventDaysData" :key="item.name" :label="item.label" :name="item.name">
                                    <div v-if="item.data.length === 0">暂无患者</div>
                                    <list-view v-else :columns="columns" :datalist="item.data" @extrabutton-click="ExtraButtonClick" :tableHeight="280" :showSequence="false"></list-view>
                                </el-tab-pane>
                            </el-tabs>
                        </div>
                        <div v-else style="font-size: 14px; text-align: left; margin: 10px">
                            <ul>
                                <li :key="index" v-for="(msg, index) in messages">
                                    <div class="ellipsis margin5 margin-none-h" :class="msg.is_read ? '' : 'unRead'">
                                        {{ msg.sender }}
                                        {{ msg.receive_date }}
                                        {{ msg.content }}
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </el-col>
            </draggable>

            <!-- <el-col :md="12" :xl="8">
                <div class="grid-content" :style="{ height: `${(this.screenHeight - 150) / 2}px` }">
                    <div class="card">
                        <i class="el-icon-s-custom"></i>
                        <span>患者板块</span>
                    </div>
                    <el-row :gutter="5" style="margin-top: 10px">
                        <el-col :span="8" v-for="(menu, index) in patientmenus" :key="index">
                            <el-button @click="gotoLink(menu.url)" type="primary" size="mini">{{ menu.name }}</el-button>
                        </el-col>
                    </el-row>
                </div>
            </el-col> -->
        </el-row>
    </div>
</template>
<script>
import draggable from 'vuedraggable'
import { mapGetters } from 'vuex'
import ECharts from 'vue-echarts/components/ECharts'
export default {
    name: `Portal`,
    components: {
        'v-chart': ECharts,
        draggable
    },
    props: {},
    data() {
        // 监听页面回传消息
        window.addEventListener(`message`, event => {}, false)
        return {
            title: `首页`,
            workbar: undefined,
            dic_ward_id: undefined,
            // patientmenus: [],
            deptmenus: [],
            Statistics_Done: [],
            Statistics_Scheduled: [],
            radToday: `1`,
            radTomorrow: `1`,
            surgeries: [],
            surgeries2: [],
            messages: [],
            activeName: `mine`,
            activeName1: `mine`,
            activeName2: `mine`,
            xAxis: [], // x轴
            currentMonth: [],
            nextMonth: [],
            todayData: [],
            tomorrowData: [],
            seventDaysData: [],
            datalist: [],
            firstUrl: ``,
            menus: [],
            orderParts: [
                {
                    user_name: ``,
                    display_order: 1,
                    enabled: true,
                    col_name: `手术管理`,
                    page_name: `IndexPage`,
                    type: `Part`
                },
                { user_name: ``, display_order: 2, enabled: true, col_name: `月度手术例数`, page_name: `IndexPage`, type: `Part` },
                {
                    user_name: ``,
                    display_order: 3,
                    enabled: true,
                    col_name: `今日手术患者`,
                    page_name: `IndexPage`,
                    type: `Part`
                },
                {
                    user_name: ``,
                    display_order: 4,
                    enabled: true,
                    col_name: `明日手术患者`,
                    page_name: `IndexPage`,
                    type: `Part`
                },
                {
                    user_name: ``,
                    display_order: 5,
                    enabled: true,
                    col_name: `7日手术患者`,
                    page_name: `IndexPage`,
                    type: `Part`
                },
                {
                    user_name: ``,
                    display_order: 6,
                    enabled: true,
                    col_name: `消息中心`,
                    page_name: `IndexPage`,
                    type: `Part`
                }
            ],
            homepageSurgeryConfig: this.$root.HomepageSurgeryConfig && this.$root.HomepageSurgeryConfig == `1`,
            themePrimary: this.$getThemePrimaryColor()
        }
    },

    created() {
        this.$nextTick(function() {
            this.init()
            this.loadPatientList()
        })
        // this.getDeptMenus()
        // this.getPatientMenus()
        this.loadMessageList()
        this.loadOrderParts()
    },
    mounted() {
        this.themePrimary = this.$getThemePrimaryColor()
        window.addEventListener(`app-theme-changed`, this.handleThemeChanged)
    },
    beforeDestroy() {
        window.removeEventListener(`app-theme-changed`, this.handleThemeChanged)
    },
    computed: {
        // 定义简单运算、数据筛选等
        ...mapGetters([`screenHeight`, `active_ward`, `layout/reset`, `routers`, `sys_enums`, `business`, `currentUser`]),
        charts() {
            return [
                {
                    title: {
                        text: `今日手术完成情况`,
                        left: `center`,
                        textStyle: {
                            fontWeight: `normal`,
                            fontSize: `14`
                        }
                    },
                    tooltip: {
                        trigger: `item`,
                        formatter: `{a} <br/>{b} : {c} ({d}%)`
                    },
                    legend: {
                        bottom: `left`,
                        formatter: `{name}`,
                        data: [`已完成`, `未完成`, `已取消`]
                    },
                    color: [`#C23531`, this.themePrimary, `#61A0A8`],
                    series: [
                        {
                            name: `今日手术完成情况`,
                            type: `pie`,
                            radius: `50%`,
                            label: {
                                normal: {
                                    position: `inner`,
                                    show: true,
                                    textStyle: {
                                        fontWeight: 300,
                                        fontSize: 16
                                    },
                                    formatter: `{d}%`
                                }
                            },
                            center: [`50%`, `55%`],
                            data: this.Statistics_Done
                        }
                    ]
                },
                {
                    title: {
                        text: `手术排程完成率`,
                        left: `center`,
                        textStyle: {
                            fontWeight: `normal`,
                            fontSize: `14`
                        }
                    },
                    tooltip: {
                        trigger: `item`,
                        formatter: `{a} <br/>{b} : {c} ({d}%)`
                    },
                    legend: {
                        bottom: `left`,
                        data: [`已完成`, `未完成`]
                    },
                    color: [`#46629D`, this.themePrimary],
                    series: [
                        {
                            name: `手术排程完成率`,
                            type: `pie`,
                            radius: `50%`,
                            label: {
                                normal: {
                                    position: `inner`,
                                    show: true,
                                    textStyle: {
                                        fontWeight: 300,
                                        fontSize: 16
                                    },
                                    formatter: `{d}%`
                                }
                            },
                            center: [`50%`, `55%`],
                            data: this.Statistics_Scheduled,
                            emphasis: {
                                itemStyle: {
                                    shadowBlur: 10,
                                    shadowOffsetX: 0,
                                    shadowColor: `rgba(0, 0, 0, 0.5)`
                                }
                            }
                        }
                    ]
                }
            ]
        },
        option() {
            let that = this
            return {
                tooltip: {
                    trigger: `axis`,
                    formatter: function(params) {
                        let msg = ``
                        if (params[0]) {
                            msg = `${params[0].axisValue}<br>${params[0].seriesName}: ${params[0].value} 例<br>`
                        }
                        if (params[1]) {
                            msg += `${params[1].seriesName}: ${params[1].value} 例`
                        }
                        return msg
                    },
                    // 指示器
                    axisPointer: {
                        type: `line`,
                        lineStyle: {
                            color: `#7171C6`
                        }
                    }
                },
                legend: {
                    data: [`本月`, `上个月`],
                    // bottom:'left',
                    top: `20`
                },
                color: [`#46629D`, this.themePrimary],
                xAxis: {
                    type: `category`,
                    axisLine: {
                        lineStyle: {
                            color: `#A9A9A9` // 坐标轴的颜色
                        }
                    },
                    boundaryGap: false,
                    data: that.xAxis
                },
                yAxis: {
                    type: `value`,
                    name: `手术例数(例)`,
                    axisLine: {
                        lineStyle: {
                            color: `#A9A9A9` // 坐标轴的颜色
                        }
                    }
                    // axisLabel:{
                    //   formatter:`{value}(例)`
                    // }
                },
                series: [
                    {
                        name: `本月`,
                        type: `line`,
                        stack: `总量1`,
                        smooth: true,
                        data: that.currentMonth
                    },
                    {
                        name: `上个月`,
                        type: `line`,
                        stack: `总量2`,
                        data: that.nextMonth
                    }
                ]
            }
        },
        columns() {
            return [
                {
                    type: `id`,
                    prop: `id`,
                    label: `序号`,
                    isKey: true
                },
                {
                    type: `string`,
                    prop: `plan_time`,
                    label: `时间`,
                    isListable: false
                },
                {
                    type: `string`,
                    prop: `surgery_status`,
                    label: `状态`,
                    isListable: true,
                    width: `100`
                },
                {
                    type: `string`,
                    prop: `room`,
                    label: `手术间`,
                    isListable: true,
                    width: `100`
                },
                {
                    type: `string`,
                    prop: `patient`,
                    label: `患者姓名`,
                    isListable: true,
                    width: `100`
                },
                {
                    type: `string`,
                    prop: `surgeries`,
                    label: `手术名称`,
                    isListable: true
                },
                {
                    type: `buttongroup`,
                    prop: `oper`,
                    label: `操作`,
                    isListable: true,
                    width: `100`,
                    options: function(that, { row }) {
                        if (row.warning === ``) {
                            return [
                                {
                                    class: `is-circle`,
                                    icon: `el-icon-right`,
                                    type: `primary`,
                                    size: `mini`,
                                    emit: `linkToPatient`,
                                    permission: `default`
                                }
                            ]
                        } else {
                            return [
                                {
                                    class: `is-circle`,
                                    icon: `el-icon-right`,
                                    type: `primary`,
                                    size: `mini`,
                                    emit: `linkToPatient`,
                                    permission: `default`
                                },
                                {
                                    class: `is-circle`,
                                    icon: `el-icon-bell`,
                                    type: `warning`,
                                    size: `mini`,
                                    tooltip: row.warning,
                                    isTooltip: true,
                                    permission: `default`
                                }
                            ]
                        }
                    }
                }
            ]
        },
        user() {
            return this.currentUser && this.currentUser.username
        },
        reflash() {
            return this[`layout/reset`]
        }
    },
    methods: {
        handleThemeChanged() {
            this.themePrimary = this.$getThemePrimaryColor()
        },
        init() {
            let that = this
            that.dic_ward_id = this.active_ward && this.active_ward.value && this.active_ward.value.split(`_`)[1]
            if (!that.dic_ward_id) {
                return
            }

            return new Promise(resolve => {
                let req = this.myaxios.getNoloading(`/api/Operation/Home/Statistics_Done?wardId=${that.dic_ward_id}`) // 当前科室今日手术完成率
                let req1 = this.myaxios.getNoloading(`/api/Operation/Home/Statistics_Scheduled?wardId=${that.dic_ward_id}`) // 当前科室今日手术排程率
                let req2 = this.myaxios.getNoloading(`/api/Operation/Home/Statistics_Month?wardId=${that.dic_ward_id}`)
                that.myaxios.all(req, req1, req2).then(([data, data1, data2]) => {
                    data2 = _.groupBy(data2, `code`)
                    let r = data2[`上月`].length > data2[`本月`].length ? data2[`上月`] : data2[`本月`] // 获取当月天数最大的x轴
                    that.xAxis = _.map(r, d => {
                        return `${that.$moment(d.value).format(`DD`)}日`
                    })
                    that.currentMonth = _.map(data2[`本月`] || [], d => {
                        return parseInt(d.label)
                    })
                    that.nextMonth = _.map(data2[`上月`] || [], d => {
                        return parseInt(d.label)
                    })
                    data = [
                        { value: data.done, name: `已完成` },
                        { value: data.cancel, name: `已取消` },
                        { value: data.scheduled, name: `未完成` }
                    ]
                    data1 = [
                        { value: data1.scheduled, name: `已完成` },
                        { value: data1.total - data1.scheduled, name: `未完成` }
                    ]
                    that.Statistics_Done = data
                    that.Statistics_Scheduled = data1
                })
            })
        },
        loadPatientList() {
            let that = this
            that.dic_ward_id = this.active_ward && this.active_ward.value && this.active_ward.value.split(`_`)[1]
            if (!that.dic_ward_id) {
                return
            }
            return new Promise(resolve => {
                let req = this.myaxios.getNoloading(`/api/Operation/Home/GetToday?wardId=${that.dic_ward_id}`)
                let req1 = this.myaxios.getNoloading(`/api/Operation/Home/GetTomorrow?wardId=${that.dic_ward_id}`)
                let req2 = this.myaxios.getNoloading(`/api/Operation/Home/GetSeventDays?wardId=${that.dic_ward_id}`)
                this.myaxios.all(req, req1, req2).then(([data, data1, data7]) => {
                    data = _.map(data, d => {
                        return {
                            id: d.id,
                            enum_surgery_status: d.enum_surgery_status,
                            surgery_status: _.filter(this.sys_enums.SurgeryStatus, { value: d.enum_surgery_status })[0].label,
                            is_mine: d.is_mine,
                            room: d.room,
                            patient: d.patient,
                            plan_time: d.plan_time,
                            surgeries: d.surgeries && d.surgeries.length > 8 ? `${d.surgeries.substr(0, 8)}...` : d.surgeries,
                            warning: d.warning,
                            enum_surgerytype: d.enum_surgerytype // 2 择期 1 急诊
                        }
                    })

                    data1 = _.map(data1, d => {
                        return {
                            id: d.id,
                            enum_surgery_status: d.enum_surgery_status,
                            surgery_status: _.filter(this.sys_enums.SurgeryStatus, { value: d.enum_surgery_status })[0].label,
                            is_mine: d.is_mine,
                            room: d.room,
                            patient: d.patient,
                            plan_time: d.plan_time,
                            surgeries: d.surgeries && d.surgeries.length > 8 ? `${d.surgeries.substr(0, 8)}...` : d.surgeries,
                            warning: d.warning
                        }
                    })

                    data7 = _.map(data7, d => {
                        return {
                            id: d.id,
                            enum_surgery_status: d.enum_surgery_status,
                            surgery_status: _.filter(this.sys_enums.SurgeryStatus, { value: d.enum_surgery_status })[0].label,
                            is_mine: d.is_mine,
                            room: d.room,
                            patient: d.patient,
                            plan_time: d.plan_time,
                            surgeries: d.surgeries && d.surgeries.length > 8 ? `${d.surgeries.substr(0, 8)}...` : d.surgeries,
                            warning: d.warning
                        }
                    })

                    let mine = _.filter(data, { is_mine: true })
                    let ongoing = _.filter(data, { enum_surgery_status: 30 })
                    let notstart = _.filter(data, { enum_surgery_status: 20 })
                    let emergencytreatment = _.filter(data, { enum_surgerytype: 1 })
                    let choosedate = _.filter(data, { enum_surgerytype: 2 })

                    let qk = _.cloneDeep(data)
                    let qk1 = _.cloneDeep(data1)
                    let qk7 = _.cloneDeep(data7)
                    console.log(`homepageSurgeryConfig`, that.homepageSurgeryConfig)
                    if (that.homepageSurgeryConfig) {
                        qk = _.filter(data, d => {
                            return d.enum_surgery_status != -1
                        })
                        emergencytreatment = _.filter(emergencytreatment, d => {
                            return d.enum_surgery_status != -1
                        })
                        choosedate = _.filter(choosedate, d => {
                            return d.enum_surgery_status != -1
                        })
                        qk1 = _.filter(qk1, d => {
                            return d.enum_surgery_status != -1
                        })
                        qk7 = _.filter(qk7, d => {
                            return d.enum_surgery_status != -1
                        })
                    }
                    this.todayData = [
                        {
                            label: `我的(${mine.length})`,
                            name: `mine`,
                            data: mine
                        },
                        {
                            label: `全科(${qk.length})`,
                            name: `all`,
                            data: qk
                        },
                        {
                            label: `进行中(${ongoing.length})`,
                            name: `ongoing`,
                            data: ongoing
                        },
                        {
                            label: `未开台(${notstart.length})`,
                            name: `notstart`,
                            data: notstart
                        },

                        {
                            label: `急诊(${emergencytreatment.length})`,
                            name: `emergencytreatment`,
                            data: emergencytreatment
                        },
                        {
                            label: `择期(${choosedate.length})`,
                            name: `choosedate`,
                            data: choosedate
                        }
                    ]
                    this.tomorrowData = [
                        {
                            label: `我的(${_.filter(data1, { is_mine: true }).length})`,
                            name: `mine`,
                            data: _.filter(data1, { is_mine: true })
                        },
                        {
                            label: `全科(${qk1.length})`,
                            name: `all`,
                            data: qk1
                        }
                    ]
                    this.seventDaysData = [
                        {
                            label: `我的(${_.filter(data7, { is_mine: true }).length})`,
                            name: `mine`,
                            data: _.filter(data7, { is_mine: true })
                        },
                        {
                            label: `全科(${qk7.length})`,
                            name: `all`,
                            data: qk7
                        }
                    ]
                })
            })
        },
        getDeptMenus() {
            let req = this.myaxios.getNoloading(`/api/AcisSystem/Authorization/DepartmentLevelMenus`)
            req.then(data => {
                this.deptmenus = _.take(data, 20)
            }).catch(e => {})
        },
        // getPatientMenus() {
        //     let req = this.myaxios.get(`/api/AcisSystem/Authorization/PatientLevelMenus`)
        //     req.then(data => {
        //         let parentId = data[0].parent_id
        //         let r = _.filter(this.routers, d => {
        //             return d.name.split(`_`)[1] == parentId
        //         })
        //         this.menus = r[0].children
        //         this.workbar = r[0].meta.workbar
        //         this.patientmenus = data
        //     }).catch(e => { })
        // },
        gotoLink(link) {
            let url = link.indexOf(`/`) === -1 ? `/${this.workbar}/${link}` : `/${this.workbar}${link}`
            this.$router.push({ path: url })
        },
        loadMessageList() {
            let req = this.myaxios.getNoloading(
                `/api/Operation/MessageReceive/Get?from=${this.$moment()
                    .add(-7, `Day`)
                    .format(`YYYY-MM-DD`)}&to=${this.$moment().format(`YYYY-MM-DD`)}`
            )
            req.then(data => {
                this.messages = _.take(
                    _.filter(data, d => {
                        return d.biz_message_content.enum_message_status === 1
                    }),
                    10
                ).map(d => {
                    return {
                        receive_date: `【${this.$moment(d.receive_date).format(`MM-DD HH:mm`)}】`,
                        content: d.biz_message_content.content,
                        sender: d.biz_message_content.sender,
                        is_read: d.is_read
                    }
                })
            }).catch(e => {
                console.log(e)
            })
        },
        changeHandler() {},
        handleClick() {},
        handleClick1() {},
        handleClick2() {},
        tabClick() {},
        ExtraButtonClick(target) {
            this[target.emit] && this[target.emit](target)
        },
        linkToPatient({ row }) {
            console.log(row)
            let date = this.$moment(row.plan_time).format(`YYYY/MM/DD`)
            let r = _.find(this.business, { business_level: `M003`, location: `basic_info` })
            let url = (r && `${r.url}?surgery_id=${row.id}&rdate=${date}`) || `/`
            this.$router.push(url)
        },
        linkToMessage() {
            let r = _.find(this.business, { business_level: `M005` })
            this.$router.push(`${(r && r.url) || `/`}`)
        },
        exchangeParts($event) {
            let that = this
            let {
                moved: { newIndex, oldIndex }
            } = $event
            if (oldIndex == newIndex) return
            _.forEach(that.orderParts, (part, index) => {
                part.display_order = index + 1
                part.user_name = that.currentUser.username
                part.enabled = true
                part.page_name = `IndexPage`
                part.type = `Part`
            })
            let req = that.myaxios.put(`/api/AcisSystem/HomePageOrderConfig/MovePartPost`, that.orderParts)
            req.then(data => {
                that.$message.success(`拖动排序成功`)
            }).catch(e => {
                that.$message.error(`拖动排序失败`)
            })
        },
        loadOrderParts() {
            let that = this
            return new Promise(resolve => {
                let userOrderParts = []
                let req = this.myaxios.getNoloading(`/api/AcisSystem/HomePageOrderConfig/Get`)
                let req1 = this.$store.dispatch(`ADD_CURRENTUSER`)
                this.myaxios.all(req, req1).then(([data]) => {
                    userOrderParts = _.filter(data, { user_name: this.user })
                    that.orderParts = userOrderParts && userOrderParts.length > 0 ? userOrderParts : that.orderParts
                    that.orderParts = _.orderBy(that.orderParts, `display_order`, `asc`)
                })
            })
        }
    },
    watch: {
        radToday: function(val) {
            this.surgeries = this.surgeries2.filter(function(s) {
                if (val == `1`) {
                    return s.is_own_data_auth_filter === false
                } else {
                    return s.is_own_data_auth_filter === true
                }
            })
        },
        active_ward: function(newValue, oldValue) {
            this.init()
            this.loadPatientList()
            // this.getDeptMenus()
            // this.getPatientMenus()
        },
        // 刷新页面，把页面区域重置成原始首页排序
        reflash: function(newValue, oldValue) {
            this.orderParts = this.$options.data().orderParts
        }
    }
}
</script>
<style scoped lang="less">
ul,
li {
    list-style: none;
    margin: 0;
    padding: 0;
}
.card {
    font-size: 16px;
    background: #ccc;
    color: #495060;
    height: 40px;
    text-align: left;
    line-height: 40px;
    padding: 0 10px;
}

.el-button {
    margin: 5px 2px !important;
    border-width: 0px;
    width: 95px;
    height: 26px;
    background: inherit;
    background-color: var(--primary-light, rgba(224, 242, 241, 1));
    border: none;
    border-radius: 0px;
    -moz-box-shadow: none;
    -webkit-box-shadow: none;
    box-shadow: none;
    color: var(--primary-color, #3db5ba);
}
.grid-content {
    /*min-height: 300px;*/
    border-radius: 4px;
    background-color: white;
    color: var(--primary-color, #3db5ba);
    border: 1px solid #ccc;
}
.grid-content.notify {
    background: rgba(251, 140, 0, 1);
    color: white;
}
.el-col {
    padding: 5px;
}

.unRead {
    &::before {
        content: '';
        background: red;
        display: inline-block;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        position: relative;
        margin-right: 2px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Portal/Index.vue